package at.theatervogelweide.admin.contract

import kotlinx.serialization.Serializable

/**
 * A row as the web app last saw it. Every table has a `version` for optimistic locking: a change names the version it
 * starts from, and the server refuses it with [AdminError.conflict] once someone else has changed the row since.
 */
@Serializable
data class VersionedId(
    val id: Long,
    val version: Long,
)

/** A copy of the list with the element at [from] moved to [to]; both are indices into this list. */
fun <T> List<T>.moved(from: Int, to: Int): List<T> {
    require(from in indices && to in indices) { "Cannot move $from to $to in a list of $size" }
    if (from == to) {
        return this
    }

    return toMutableList().apply { add(to, removeAt(from)) }
}
